export const siftBeaconId = '01c5132de7';
